// extracted by mini-css-extract-plugin
export default {"teamReportPanelTab":"team-report-panel-tab_teamReportPanelTab__kUH8U"};